<div class="support-outage-layout" *ngIf="supportOutageAlert$ | async">
    <div class="content-wrapper">
        <mat-icon [svgIcon]="'warning'" aria-hidden />
        <span>
            {{ statusTitle }}{{ timeZone }}.
            @if (showCTA) {
                <button
                    *appDesktop
                    (click)="handleOpenDialog()"
                    matTooltip="Learn more"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="2000"
                    [attr.data-analytics]="dataAnalyticsLearnMore">
                    {{ statusPageCta }}
                    <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                </button>
                <a *appMobile [href]="statusPageUrl" target="_blank">
                    {{ statusPageCta }}
                    <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
                </a>
            }
        </span>
    </div>
    <button
        aria-label="Close"
        (click)="closeAlert()"
        matTooltip="Close"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000"
        [attr.data-analytics]="dataAnalyticsClose">
        <mat-icon [svgIcon]="'close'" aria-hidden></mat-icon>
    </button>
</div>
